/**
 * 達成率のバー(0〜100% の目盛り。100% を超えたら満タン＋達成の色)。業務ロジックは持たない
 * (何に対する率か・目標の文言は呼び出し側が決める)。
 */
import type { ReactNode } from 'react';
import { formatPercent } from '@core/utils/formatters';

const MARKS = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export default function ProgressBar({ value, label, goal }: { value: number | null; label: string; goal?: ReactNode }) {
  const pct = value === null || !Number.isFinite(value) ? 0 : Math.max(0, value);
  const done = pct >= 100;
  return (
    <div className="ui-progress">
      <div
        className="ui-progress-track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.min(100, Math.round(pct))}
        aria-valuetext={value === null ? 'データなし' : formatPercent(value)}
      >
        <div className={`ui-progress-fill${done ? ' is-done' : ''}`} style={{ width: `${Math.min(100, pct)}%` }} />
        {goal && <span className={`ui-progress-goal${done ? ' is-done' : ''}`}>{goal}</span>}
      </div>
      <div className="ui-progress-scale" aria-hidden="true">
        {MARKS.map((m) => (
          <span key={m}>{m}%</span>
        ))}
      </div>
    </div>
  );
}
